<!-- 对话框容器 -->
<template>
    <el-container>
        <!-- 1.header区域 -->
      <el-header class="operations-herder">
        <slot name="header"></slot>
      </el-header>
      <!-- 2.内容填充区域 -->
      <el-main>
        <div class="main-content" :style="{height: contentHeight +'px'}">
           <slot name="content"></slot>
        </div>
      </el-main>
      <!-- 3. footer区域-->
      <el-footer>
        <div class="operations-button-box">
            <slot name="footer"></slot>
        </div>
      </el-footer>
    </el-container>
</template>

<script setup>
import { toRefs } from 'vue'
const props = defineProps({
    contentHeight: {
        type: Number,
        default: 260
    }
})
/* contentHeight 参数用来决定content内容区域的高度 type为数字类型 */
const { contentHeight } = toRefs(props)
</script>

<style lang="scss" scoped>
.main-content {
    overflow: auto;
}
.operations-button {
    display: flex;
    justify-content: center;
}
.operations-herder {
    justify-content: center;
    font-weight: bold;
}
:deep(.el-footer){
    height: 80px;
}
.operations-button-box {
    display: flex;
    justify-content: center;
}
</style>